import React, { useState } from "react";

const ImageSelectionModal = ({ 
  isOpen, 
  onClose, 
  images, 
  contestName, 
  contestCategory,
  onConfirm,
  isJoining 
}) => {
  const [selectedImageId, setSelectedImageId] = useState(null);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (selectedImageId) {
      onConfirm(selectedImageId);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
      <div className="bg-[#1C1C1E] rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <h2 className="text-2xl font-bold mb-2 text-[#ceb46a]">Select Image for Contest</h2>
        <p className="text-white mb-4">
          Contest: <strong>{contestName}</strong>
        </p>
        <p className="text-gray-400 mb-6">
          Category: <strong>{contestCategory}</strong> - Select which image you want to enter
        </p>

        {images && images.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-6">
            {images.map((image) => (
              <div
                key={image.id}
                onClick={() => setSelectedImageId(image.id)}
                className={`relative cursor-pointer rounded-lg overflow-hidden border-4 transition-all ${
                  selectedImageId === image.id
                    ? "border-[#ceb46a] ring-2 ring-[#ceb46a]"
                    : "border-transparent hover:border-gray-600"
                }`}
              >
                <img
                  src={image.image_url || image.image}
                  alt={`${image.body_part} image`}
                  className="w-full h-48 object-cover"
                />
                {selectedImageId === image.id && (
                  <div className="absolute top-2 right-2 bg-[#ceb46a] rounded-full p-1">
                    <svg
                      className="w-6 h-6 text-black"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                )}
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-70 p-2">
                  <p className="text-white text-sm text-center">{image.body_part}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8 text-gray-400">
            <p>No images found for this category</p>
          </div>
        )}

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-6 py-2 border-2 border-gray-600 rounded-lg text-white hover:bg-gray-800 transition-colors"
            disabled={isJoining}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className="px-6 py-2 bg-[#ceb46a] text-black rounded-lg hover:bg-[#b99d55] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={!selectedImageId || isJoining}
          >
            {isJoining ? "Joining..." : "Confirm & Join Contest"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageSelectionModal;

